import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material"
import { Assessment } from "@mui/icons-material"

const RecentActivities = () => {
  const activities = [
    { user: "Ahmed Hasan", action: "added a new product", time: "5 minutes ago" },
    { user: "Fatima Khan", action: "created an invoice", time: "15 minutes ago" },
    { user: "Rahim Uddin", action: "updated stock", time: "30 minutes ago" },
    { user: "Salma Begum", action: "added a new customer", time: "1 hour ago" },
  ]

  return (
    <Card>
      <CardHeader
        avatar={<Assessment color="primary" />}
        title="Recent Activities"
        subheader="List of recent system activities"
      />
      <CardContent sx={{ pt: 0 }}>
        <List>
          {activities.map((activity, index) => (
            <ListItem
              key={index}
              sx={{
                bgcolor: "#f5f5f5",
                borderRadius: 1,
                mb: 1,
                "&:last-child": { mb: 0 },
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: "primary.main" }}>{activity.user.charAt(0)}</Avatar>
              </ListItemAvatar>
              <ListItemText primary={activity.user} secondary={activity.action} />
              <Typography variant="caption" color="text.secondary">
                {activity.time}
              </Typography>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  )
}

export default RecentActivities
